import { ErrorOutline } from '@mui/icons-material';
import { ConfirmationDialog } from '../ConfirmationDialog';
import { Subproject } from './types';

interface ProjectCardDialogsProps {
  // Pencils Down Dialog
  pencilsDownDialogOpen: boolean;
  projectName: string;
  onPencilsDownConfirm: () => void;
  onPencilsDownCancel: () => void;

  // Delete Project Dialog
  deleteDialogOpen: boolean;
  onDeleteProjectConfirm: () => void;
  onDeleteProjectCancel: () => void;

  // Delete Archived Project Dialog
  deleteArchivedDialogOpen: boolean;
  onDeleteArchivedConfirm: () => void;
  onDeleteArchivedCancel: () => void;

  // Delete Subproject Dialog
  deleteSubprojectDialogOpen: boolean;
  subprojectToDelete: Subproject | null;
  onDeleteSubprojectConfirm: () => void;
  onDeleteSubprojectCancel: () => void;
}

export function ProjectCardDialogs({
  pencilsDownDialogOpen,
  projectName,
  onPencilsDownConfirm,
  onPencilsDownCancel,
  deleteDialogOpen,
  onDeleteProjectConfirm,
  onDeleteProjectCancel,
  deleteArchivedDialogOpen,
  onDeleteArchivedConfirm,
  onDeleteArchivedCancel,
  deleteSubprojectDialogOpen,
  subprojectToDelete,
  onDeleteSubprojectConfirm,
  onDeleteSubprojectCancel,
}: ProjectCardDialogsProps) {
  return (
    <>
      {/* Pencils Down Warning Dialog */}
      <ConfirmationDialog
        open={pencilsDownDialogOpen}
        icon={<ErrorOutline sx={{ fontSize: 48, color: 'text.primary' }} />}
        title={`Are you sure you want to set ${projectName} as "Pencils Down"?`}
        message='Users will no longer be able to make edits to the current decarb flow.'
        confirmLabel='Yes'
        cancelLabel='No'
        confirmColor='info'
        onConfirm={onPencilsDownConfirm}
        onCancel={onPencilsDownCancel}
      />

      {/* Delete Project Warning Dialog */}
      <ConfirmationDialog
        open={deleteDialogOpen}
        title='Delete Project'
        message='Are you sure you want to permanently delete this project? This action cannot be undone.'
        confirmLabel='Delete'
        confirmColor='error'
        onConfirm={onDeleteProjectConfirm}
        onCancel={onDeleteProjectCancel}
      />

      {/* Delete Archived Project Warning Dialog */}
      <ConfirmationDialog
        open={deleteArchivedDialogOpen}
        title='Delete Archived Project'
        message='Are you sure you want to permanently delete this archived project? This action cannot be undone.'
        confirmLabel='Delete'
        confirmColor='error'
        onConfirm={onDeleteArchivedConfirm}
        onCancel={onDeleteArchivedCancel}
      />

      {/* Delete Subproject Warning Dialog */}
      <ConfirmationDialog
        open={deleteSubprojectDialogOpen}
        title='Delete Subproject'
        message={`Are you sure you want to permanently delete "${subprojectToDelete?.name}"? This action cannot be undone.`}
        confirmLabel='Delete'
        confirmColor='error'
        onConfirm={onDeleteSubprojectConfirm}
        onCancel={onDeleteSubprojectCancel}
      />
    </>
  );
}
